import React, {Component} from 'react';
import ReactTooltip from 'react-tooltip'

import {t} from 'l10n';

import 'sass/VirtualGiftCatalogItem.scss';

class VirtualGiftCatalogItem extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {
        const {giftCatalogItem, onClick} = this.props;

        let tooltipKey = 'virtual-gift-catalog-item'+giftCatalogItem.id;

        return (
           <div className="virtual-gift-catalog-item" onClick={() => onClick(giftCatalogItem)}>
               <div className="img">
                   <img src={giftCatalogItem.thumbnail_url} alt="" data-tip data-for={tooltipKey} />
                   <ReactTooltip
                       id={tooltipKey}
                       type="light"
                       place="right"
                       class="tooltip-fon"
                   >
                       <img src={giftCatalogItem.full_url} alt="" />
                   </ReactTooltip>
               </div>
               <div className="text">
                   <div className="namegift">
                       {giftCatalogItem.name}
                   </div>
                   <div className="points">
                       {t('%1 tokens', giftCatalogItem.points)}
                   </div>
               </div>
           </div>
        )
    }
}

export default VirtualGiftCatalogItem;


// WEBPACK FOOTER //
// ./src/components/virtualgift/VirtualGiftCatalogItem.js